import { render, staticRenderFns } from "./BulkConfirmationDialog.vue?vue&type=template&id=13d6217e"
import script from "./BulkConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BulkConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports